import * as React from "react";
import {
  Avatar,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { Done } from "@mui/icons-material";
import { green } from "@mui/material/colors";

export default function UsersConfirmation(props: {
  title: string;
  body?: string;
  open: boolean;
  setOpen: any;
}) {
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    props.setOpen(false);
  };

  return (
    <Box>
      <Dialog
        open={props.open}
        onClose={handleCloseDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={2}
            alignItems="center"
            justifyContent="center"
            sx={{ mb: 2 }}
          >
            <Grid item xs={12} sx={{ mt: 2 }}>
              <Stack alignItems="center" justifyContent="center" spacing={2}>
                <Box display="flex" alignItems="center" justifyContent="center">
                  <Avatar sx={{ bgcolor: green[500], width: 80, height: 80 }}>
                    <Done sx={{ width: 50, height: 50 }} />
                  </Avatar>
                </Box>
                <Typography variant="h4" textAlign="center">
                  {props.title}
                </Typography>
              </Stack>
            </Grid>
            {props.body && (
              <Grid item xs={12}>
                <Typography variant="h2">{props.body}</Typography>
              </Grid>
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog}>{t("Cancel")}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
